import { useId } from 'react';

export default function useUniqueId(customId?: string) {
  const id = useId();

  return customId || id;
}
